import React from "react"

import classNames from "classnames"

import { LoadingRows, LoadingRowsProps } from "./LoadingRows"

export interface LoadingTableProps extends LoadingRowsProps {
  containerProps?: React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>>
}

function LoadingTableComponent({
  containerProps,
  ...props
}: LoadingTableProps) {
  return (
    <div
      {...containerProps}
      className={classNames("treegrid", containerProps?.className)}
      role={containerProps?.role ?? "grid"}
    >
      <LoadingRows {...props} />
    </div>
  )
}

export const LoadingTable = React.memo(LoadingTableComponent)
